import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import theme from "../../theme";
import CommonButton from "../button";
import CommonInput from "../input";
import { Constants } from "../../lib/constant";

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: theme.colors.White,
    padding: "45px 90px",
    boxShadow: "0px 0px 10px #CFD9EA80",
    borderRadius: "15px",
    width: "350px",
    margin: "0 auto",
    "& .title": {
      color: theme.colors.DodgerBlue,
      fontSize: "24px",
      fontFamily: theme.fontFamily.MARKPROBOLD,
      marginBottom: "20px",
    },
  },
}));

function InviteMerchant({ inviteMerchantMethod, dashboardReducer }) {
  const classes = useStyles();

  const [formData, setFormData] = useState({
    businessName: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    settlementChargePercentage: "0.00",
    isValidated: false,
    methodCalled: false,
  });

  return (
    <>
      {formData.methodCalled && dashboardReducer?.inviteMerchantError?.length ? (
        <div className={"error-container"}>
          {dashboardReducer?.inviteMerchantError?.length
            ? dashboardReducer.inviteMerchantError.map((each, index) => (
              <div key={index}>{each}</div>
            ))
            : null}
        </div>
      ) : null}
      <div className={classes.root}>
        <div className="title">Invite New Merchant</div>
        <form
          autoComplete="off"
          onSubmit={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setFormData((prev) => ({ ...prev, isValidated: true, methodCalled: true }));
            if (
              formData.businessName &&
              formData.firstName &&
              formData.lastName &&
              formData.email &&
              formData.email.match(Constants.email_regex) &&
              formData.phoneNumber &&
              formData.settlementChargePercentage &&
              formData.settlementChargePercentage.trim() !== ""
            ) {
              const trimmedEmail = formData.email.trim();
              const settlementCharge = formData.settlementChargePercentage.trim() || "0.00";
              inviteMerchantMethod({
                business_name: formData.businessName.trim(),
                owner_email: trimmedEmail,
                phone_number: formData.phoneNumber.trim(),
                settlement_charge_percentage: settlementCharge,
                owner: {
                  first_name: formData.firstName.trim(),
                  last_name: formData.lastName.trim(),
                  email: trimmedEmail,
                },
              });
            }
          }}
        >
          <CommonInput
            label="Business Name"
            placeholder="Enter business name"
            type="text"
            value={formData.businessName}
            onChange={(e) => {
              setFormData((prev) => ({ ...prev, businessName: e.target.value }));
            }}
            error={formData.isValidated && !formData.businessName}
            helperText={
              formData.isValidated && !formData.businessName && "Business Name may not be blank."
            }
          />
          <CommonInput
            label="First Name"
            placeholder="Enter first name"
            type="text"
            value={formData.firstName}
            onChange={(e) => {
              setFormData((prev) => ({ ...prev, firstName: e.target.value }));
            }}
            error={formData.isValidated && !formData.firstName}
            helperText={
              formData.isValidated && !formData.firstName && "First Name may not be blank."
            }
          />
          <CommonInput
            label="Last Name"
            placeholder="Enter last name"
            type="text"
            value={formData.lastName}
            onChange={(e) => {
              setFormData((prev) => ({ ...prev, lastName: e.target.value }));
            }}
            error={formData.isValidated && !formData.lastName}
            helperText={
              formData.isValidated && !formData.lastName && "Last Name may not be blank."
            }
          />
          <CommonInput
            label="Email"
            placeholder="Enter email"
            type="text"
            value={formData.email}
            onChange={(e) => {
              setFormData((prev) => ({ ...prev, email: e.target.value.trim() }));
            }}
            error={
              formData.isValidated &&
              (!formData.email || (formData.email && !formData.email.match(Constants.email_regex)))
            }
            helperText={
              formData.isValidated &&
              ((!formData.email && "Email may not be blank.") ||
                (formData.email &&
                  !formData.email.match(Constants.email_regex) &&
                  "Email is invalid."))
            }
          />
          <CommonInput
            label="Phone Number"
            placeholder="Enter phone number"
            type="text"
            value={formData.phoneNumber}
            onChange={(e) => {
              setFormData((prev) => ({ ...prev, phoneNumber: e.target.value }));
            }}
            error={formData.isValidated && !formData.phoneNumber}
            helperText={
              formData.isValidated && !formData.phoneNumber && "Phone Number may not be blank."
            }
          />
          <CommonInput
            label="Settlement Charge Percentage"
            placeholder="Enter settlement charge percentage (e.g., 0.00)"
            type="text"
            value={formData.settlementChargePercentage}
            onChange={(e) => {
              const value = e.target.value;
              // Ensure it's never empty, default to "0.00" if cleared
              setFormData((prev) => ({ ...prev, settlementChargePercentage: value || "0.00" }));
            }}
            error={formData.isValidated && (!formData.settlementChargePercentage || formData.settlementChargePercentage.trim() === "")}
            helperText={
              formData.isValidated &&
                (!formData.settlementChargePercentage || formData.settlementChargePercentage.trim() === "")
                ? "Settlement Charge Percentage may not be blank. Use 0.00 for no charge."
                : "Use 0.00 to signify no settlement charge."
            }
          />
          <CommonButton
            type="submit"
            text="Send Invitation"
            stylevariant="secondary1"
            style={{ marginTop: "30px" }}
            disabled={
              !formData.businessName.trim() ||
              !formData.firstName.trim() ||
              !formData.lastName.trim() ||
              !formData.email.trim() ||
              !formData.email.match(Constants.email_regex) ||
              !formData.phoneNumber.trim() ||
              !formData.settlementChargePercentage ||
              formData.settlementChargePercentage.trim() === ""
            }
          />
        </form>
      </div>
    </>
  );
}

export default InviteMerchant;

